import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { HubHeader, HubFooter } from "../components/HubChrome";

export default function NotFound({ backTo = "/", backLabel = "Back to the homepage" }) {
  useEffect(() => {
    document.title = "Page not found | House Heads At Sea";
    document.head.querySelector('link[rel="canonical"]')?.remove();
    let robots = document.head.querySelector('meta[name="robots"]');
    if (!robots) {
      robots = document.createElement("meta");
      robots.setAttribute("name", "robots");
      document.head.appendChild(robots);
    }
    robots.setAttribute("content", "noindex, follow");
  }, []);
  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white flex flex-col" data-testid="not-found-page">
      <HubHeader />
      <main className="flex-1 flex items-center px-6 sm:px-12 py-32">
        <div className="max-w-xl">
          <p className="font-cond uppercase tracking-[0.3em] text-[#E50914] text-sm mb-4">Error 404</p>
          <h1 className="font-cond font-bold uppercase text-4xl sm:text-5xl lg:text-6xl mb-6" data-testid="not-found-title">Page not found</h1>
          <p className="text-white/70 text-base mb-10">The page you're looking for has sailed away or never existed.</p>
          <Link to={backTo} data-testid="not-found-back-link" className="inline-flex items-center gap-2 rounded-full bg-[#E50914] px-6 py-3 font-cond uppercase tracking-wide hover:bg-white hover:text-black transition-colors">
            <ArrowLeft className="w-4 h-4" /> {backLabel}
          </Link>
        </div>
      </main>
      <HubFooter />
    </div>
  );
}
